
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ConfirmMail extends Vue {
  private email = ' ';
 
}
